"use strict";

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _inherits = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var CharacterDataImpl = require("./CharacterData-impl").implementation;

var NODE_TYPE = require("../node-type");

var ProcessingInstructionImpl = /*#__PURE__*/function (_CharacterDataImpl) {
  _inherits(ProcessingInstructionImpl, _CharacterDataImpl);

  var _super = _createSuper(ProcessingInstructionImpl);

  function ProcessingInstructionImpl(args, privateData) {
    var _this;

    _classCallCheck(this, ProcessingInstructionImpl);

    _this = _super.call(this, args, privateData);
    _this.nodeType = NODE_TYPE.PROCESSING_INSTRUCTION_NODE;
    _this._target = privateData.target;
    return _this;
  }

  _createClass(ProcessingInstructionImpl, [{
    key: "target",
    get: function get() {
      return this._target;
    }
  }]);

  return ProcessingInstructionImpl;
}(CharacterDataImpl);

module.exports = {
  implementation: ProcessingInstructionImpl
};